import React from 'react';
import classnames from 'classnames';

export default function AppointmentPicker({
  activeSlot,
  appointmentSlots,
  onSelect,
}) {
  return (
    <div className="overflow-x-auto mt-2">
      <div className="-mx-2 sm:mx-0 flex sm:grid sm:grid-cols-7 sm:gap-x-2">
        {appointmentSlots.map((appointmentSlot, i) => (
          <div key={i} className="px-2 sm:px-0">
            <label className="form-label mb-2 w-28">
              {appointmentSlot.label}
            </label>
            <div className="space-y-2">
              {(appointmentSlot.slots || []).map((slot) => {
                const selected =
                  activeSlot &&
                  (activeSlot._id === slot._id ||
                    activeSlot.windowStart?.format() ===
                      slot.windowStart.format());
                return (
                  <AppointmentSlot
                    selected={selected}
                    appointmentSlot={slot}
                    key={slot._id}
                    onSelect={onSelect}
                  />
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function AppointmentSlot({ appointmentSlot, selected, onSelect }) {
  const { label, disabled } = appointmentSlot;

  function handleSelect() {
    onSelect(appointmentSlot);
  }

  const className = classnames('button block', {
    'button-hollow-green': !selected,
    'button-green': selected,
    'w-32': true,
  });
  return (
    <button className={className} onClick={handleSelect} disabled={disabled}>
      {label}
    </button>
  );
}
